/**
 * Maps multi chart options to position names and routes
 */

import React from 'react'
import ChartSelector from '../chart-selector'
import ChartSelectorExpanded from '../chart-selector-expanded'
import CHART_MAP from './charts/chart-map'
import RA from 'ra-config'
import { CHART_GROUP_MAP } from '../../config/charts'

function isCorrelationMatrix(name) {
  return name === 'correlationChart'
}

function getOptions(name) {
  return CHART_GROUP_MAP.factors[name].chartOptionList
}

class FactorCharts extends React.PureComponent {
  static getChart(name, query) {
    let options = getOptions(name)
    let selected = options.find(opt => opt.default === true)

    if (query.expanded === name) {
      selected =
        options.find(opt => opt.text === query.expandedSelection) || selected
    } else if (isCorrelationMatrix(name) && query.category) {
      selected =
        options.find(opt => opt.value === query.category.toLowerCase()) ||
        selected
    } else if (query[name]) {
      selected = options.find(opt => opt.value === query[name]) || selected
    }

    return selected
  }

  static defaultProps = {
    expanded: false
  }

  render() {
    const { expanded, name, query, ...dataProps } = this.props

    if (name in CHART_GROUP_MAP.factors === false) {
      return null
    }

    const props = {
      ...dataProps,
      selected: FactorCharts.getChart(name, query),
      chartMap: CHART_MAP,
      config: RA.content.factors,
      hideOptions: isCorrelationMatrix(name) && !!query.expanded,
      disableOptions: isCorrelationMatrix(name) && !!query.category,
      options: getOptions(name),
      name: name,
      query: query
    }

    return React.createElement(
      expanded ? ChartSelectorExpanded : ChartSelector,
      props
    )
  }
}

export default FactorCharts



// WEBPACK FOOTER //
// ./src/components/factors/charts.js